import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Inject,
    OnInit,
    ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { Environment } from "app/decorators/environment.decorator";
import { CalculateFormulasComponent } from "app/main/modules/operational/medical-module/components/calculate-formulas/calculate-formulas.component";
import { PrintGcpComponent } from "app/main/modules/operational/medical-module/components/print-gcp/print-gcp.component";
import { ConfigOnly } from "app/main/modules/operational/tools/document-model/document-editor/config";
import { OnllyofficeService } from "app/main/modules/operational/tools/document-model/document-editor/document-editor.service";
import { CwUtils } from "cw-utils";
import moment from "moment";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import {
    Document,
    DocumentModel,
} from "../../../../../../../../../shared/cw-backend/models/operational/tools/document-model/document-form";
import { MedicalProvider } from "../../../../../../../../../shared/cw-backend/providers/operational/medical/medical.provider";
import { DocumentModelListProvider } from "../../../../../../../../../shared/cw-backend/providers/operational/tools/document-model/document-model-list.provider";
import { ExpressionProvider } from "../../../../../../../../../shared/cw-backend/providers/operational/tools/expression/expression.provider";
import { PageOptions } from "../../../../../../../../../shared/cw-utils/cw-utils.service";
import { SnackBarService } from "../../../../../../../../../shared/cw-utils/snackbar.service";

@Component({
    selector: "app-attest-attendance",
    templateUrl: "./attest-attendance.component.html",
    styleUrls: ["./attest-attendance.component.scss"],
})
export class AttestAttendanceComponent implements OnInit, AfterViewInit {
    private _unsubscribeAll: Subject<any>;
    @ViewChild("quill") editor: ElementRef;
    modelsControl: FormControl;
    documentForm: FormControl;
    modelsList: DocumentModel[];
    isButtonDisabled: boolean = false;
    modelsPageOptions: PageOptions;
    pageOptions: PageOptions;
    nameDocument: string;
    date = new Date();
    typeDocument: number;
    pdfSrc: string = null;
    zoom: any = "page-width";
    selectedIndex: number = 0;
    document = new Document();
    configonly: ConfigOnly;
    @Environment("urlOnlyoffice") baseUrl: string;
    http: HttpClient;
    result: string;
    public innerWidth: any;
    public quillFullscreen: boolean = false;
    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;

    configEditor = {
        toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ header: 1 }, { header: 2 }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            // ['link', 'image', 'video'],
            [{ align: [] }],
            // ['clean']
        ],
    };

    constructor(
        public documentModelListProvider: DocumentModelListProvider,
        private expressionProvider: ExpressionProvider,
        public dialogRef: MatDialogRef<AttestAttendanceComponent>,
        private fuseProgressBarModule: FuseProgressBarService,
        private snackBar: SnackBarService,
        public dialog: MatDialog,
        private medicalProvider: MedicalProvider,
        private only: OnllyofficeService,
        private elementRef: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this._unsubscribeAll = new Subject();
        this.modelsControl = new FormControl();
        this.documentForm = new FormControl(
            this.document?.document ? this.document.document : null,
        );
        this.modelsPageOptions = new PageOptions();
        this.pageOptions = new PageOptions();
        this.configonly = new ConfigOnly();
    }

    ngOnInit() {
        if (this.data.documentId != null) {
            this.getDocumentById(this.data.documentId);
            this.modelsControl.disable();
        }

        this.typeDocument = this.data.type;
        this.nameDocument = this.data.nameDocument;
        this.getModelsType(this.data.type);
        this.observableModels();
        this.getDocuments();
        this.ObservableFormat();
        this.innerWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        var inputElement = document.querySelector("#quill .ql-editor");

        if (inputElement) {
            (inputElement as HTMLInputElement).focus();
        }
    }

    ngOnDestroy(): void {
        this.setQuillFullscreen(false);
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    displayFn(event?: any): string | undefined {
        if (!event) {
            return null;
        }
        return event.title;
    }

    getModelsType(type?: number) {
        this.modelsPageOptions.fieldSort = "id";

        this.documentModelListProvider
            .getPageType(this.modelsPageOptions, type)
            .then((res) => {
                this.modelsList = res.body.content;
            });
    }

    getHeight(): number {
        const width = window.innerWidth;
        if (width < 1300) {
            return 200;
        } else if (width < 1367) {
            return 300; // Defina a altura para telas menores que 768px
        } else {
            return 500; // Defina a altura para telas maiores que 992px
        }
    }

    openPanel(document, indice) {
        this.selectedIndex = indice;
        if (document.format == "docx" || document.format == "rtf") {
            this.medicalProvider.generatePdf(document).then((x) => {
                this.pdfSrc = null;
                this.zoom = "page-width";
                this.pdfSrc = x.pdf;
                var newBlob = new Blob([x], { type: "application/pdf" });
                const nav = window.navigator as any;
                if (nav && nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(newBlob);
                    return;
                }
                const data = window.URL.createObjectURL(newBlob);
            });
        } else if (document.format == "html" || document.format == "text") {
            this.medicalProvider.getDocumentById(document.id).then((res) => {
                this.result = decodeURIComponent(
                    escape(window.atob(res.body.document)),
                );
            });
        }
    }

    closedPanel(document) {
        this.pdfSrc = null;
    }

    closeModal() {
        if (this.document.id == null && this.documentForm.value != null) {
            this.insertAutomatic("html", null);
        }
        this.dialogRef.close();
    }

    insert(format: string, documentModel: any) {
        if (
            (format == "html" && this.documentForm.value == null) ||
            this.documentForm.value == ""
        ) {
            this.snackBar.warnMessage("Preencha os campos texto!");
            return;
        }

        let data = new Document();
        data.id = this.document?.id ? this.document.id : null;
        data.dateAt = new Date();
        data.dateAt = this.document?.id
            ? this.document.dateAt
            : moment(data.dateAt).format("YYYY-MM-DD");
        data.companyCostCenter = null;
        data.performer = { id: this.data.performer.id };
        data.patient = { id: this.data.patient.id };
        data.type = this.typeDocument;
        data.headerId = null;
        data.documentBasic = `<html>${this.documentForm.value}</html>`;
        data.format = format;
        data.footerId = null;
        data.documentModel = CwUtils.extractId(documentModel);
        data.editing = true;
        data.title = `Documento_${this.data.patient.id}`;

        if (documentModel == null) {
            this.medicalProvider.insert(data).then((response) => {
                this.snackBar.successMessage(response.body.message);
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }
            });
        } else {
            this.medicalProvider.newDocument(data).then((response) => {
                this.snackBar.successMessage(response.body.message);
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }
            });
        }
    }

    insertAutomatic(format: string, documentModel: any) {
        if (
            (format == "html" && this.documentForm.value == null) ||
            this.documentForm.value == ""
        ) {
            this.snackBar.warnMessage("Preencha os campos texto!");
            return;
        }

        let data = new Document();
        data.id = this.document?.id ? this.document.id : null;
        data.dateAt = new Date();
        data.dateAt = this.document?.id
            ? this.document.dateAt
            : moment(data.dateAt).format("YYYY-MM-DD");
        data.companyCostCenter = null;
        data.performer = { id: this.data.performer.id };
        data.patient = { id: this.data.patient.id };
        data.type = this.typeDocument;
        data.headerId = null;
        data.documentBasic = `<html>${this.documentForm.value}</html>`;
        data.format = format;
        data.footerId = null;
        data.documentModel = documentModel;
        data.editing = true;
        data.title = `Documento_${this.data.patient.id}`;

        if (documentModel == null) {
            this.medicalProvider.insert(data).then((response) => {
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }
            });
        } else {
            this.medicalProvider.newDocument(data).then((response) => {
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }
            });
        }
    }

    getDocumentById(idRequestModel) {
        this.medicalProvider.getById(idRequestModel).then((response) => {
            this.document = response.body;

            if (
                this.document.format == "docx" ||
                this.document.format == "rtf"
            ) {
                if (!this.document.editing) {
                    this.configonly.edit = false;
                }
                this.loadDocument();
            } else {
                if (!this.document.editing) {
                    this.documentForm.disable();
                }

                this.documentForm.setValue(
                    decodeURIComponent(
                        escape(window.atob(response.body.document)),
                    ),
                );
            }
        });
    }

    observableModels() {
        this.modelsControl.valueChanges.pipe().subscribe((res) => {
            if (res.format == "docx" || this.document.format == "rtf") {
                const confirmDialogRef = this.dialog.open(
                    FuseConfirmDialogComponent,
                    {
                        disableClose: false,
                    },
                );

                confirmDialogRef.componentInstance.action = "delete";
                confirmDialogRef.componentInstance.deleteMessage = `Deseja criar um documento a partir do modelo ${res.title}?`;

                confirmDialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        this.insert("docx", res);
                    }
                });
            } else if (res.id) {
                this.documentForm.setValue(null);
                this.medicalProvider
                    .getTextByModel(
                        res.id,
                        this.data.patient.id,
                        this.data.performer.id,
                    )
                    .then((response) => {
                        console.log(response);
                        this.documentForm.setValue(
                            decodeURIComponent(response.body),
                        );
                    });
            } else if (res) {
                this.modelsPageOptions.argument = res;
                this.getModelsType(this.data.type);
            } else {
                this.modelsPageOptions.argument = "";
                this.getModelsType(this.data.type);
            }
        });
    }

    ObservableFormat() {
        this.documentForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(700),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                this.document.documentBasic = res;
                if (this.document.id) {
                    this.insertAutomatic("html", this.document.documentModel);
                }
            });
    }

    getDocuments(event?, type?) {
        this.fuseProgressBarModule.show();

        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 10;
                break;
        }

        this.pageOptions.fieldSort = "dateAt";
        this.pageOptions.sortDirection = "desc";

        this.medicalProvider
            .getPage(
                this.pageOptions,
                this.data.patient.id,
                this.data.type,
                this.data.performer.id,
            )
            .then((document) => {
                this.data.documentList = document.body.content;
                const dados = document.body;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;

                this.fuseProgressBarModule.hide();
            })
            .catch((error) => {
                this.fuseProgressBarModule.hide();
            });
    }

    public loadDocument() {
        this.configurationOnly();
        this.openonly();
    }

    openonly() {
        if (this.document?.id != null) {
            this.only.load(); //carregando o documento

            setTimeout(() => {
                this.only.сonnectEditor(this.configonly);
            }, 2000);
        }
    }

    configurationOnly() {
        let usuario = JSON.parse(localStorage.getItem("user"));
        this.configonly.author = "ClinicAll";
        this.configonly.name = "ClinicAll";
        this.configonly.height = "100%";
        this.configonly.zoom = -2;
        this.configonly.type = "desktop";
        this.configonly.container = "docx";

        if (this.document?.id) {
            this.configonly.url = `${this.baseUrl}document/download/${
                this.document.id
            }?medico=${this.document.performer.id}&paciente=${
                this.document.patient.id
            }&sistema=${1}&X-Auth-Token=${localStorage.getItem("token")}`;
            this.configonly.callbackUrl = `${
                this.baseUrl
            }document/track?fileName=${
                this.document.id
            }&X-Auth-Token=${localStorage.getItem("token")}`;
            var hash = Math.floor(Date.now() * Math.random()).toString(36);
            this.configonly.key = `${hash}_${this.document.id}`;
        }
    }

    @HostListener("window:resize", ["$event"]) onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    @HostListener("document:keydown.escape", ["$event"])
    onEscape(event: KeyboardEvent) {
        if (this.quillFullscreen) {
            this.setQuillFullscreen(false);
        }
    }

    toggleQuillFullscreen(event?: Event) {
        if (event) {
            event.stopPropagation();
        }

        this.setQuillFullscreen(!this.quillFullscreen);
    }

    private setQuillFullscreen(active: boolean) {
        this.quillFullscreen = active;
        window.document.body.classList.toggle(
            "quill-editor-fullscreen-active",
            active,
        );
    }

    openExpression() {
        this.expressionProvider
            .checkDocumentModelIsExpression(this.document.documentModel.id)
            .then((check) => {
                if (check.data == true) {
                    const confirmDialogRef = this.dialog.open(
                        CalculateFormulasComponent,
                        {
                            data: {
                                documentModel: this.document.documentModel.id,
                                document: this.document.id,
                            },
                            width: "80%",
                        },
                    );
                    confirmDialogRef.afterClosed().subscribe((result) => {
                        this.medicalProvider
                            .documentFromExpression(this.document)
                            .then((documentFromExpresison) => {
                                if (documentFromExpresison.body.data.id) {
                                    this.loadDocument();
                                }
                            });
                    });
                } else {
                    this.loadDocument();
                }
            });
    }

    checkExpression() {
        if (this.document.id) {
            this.expressionProvider
                .checkDocumentExpressionExists(this.document.id)
                .then((check) => {
                    if (check.data == true) {
                        this.only.onDestroyEditor();
                        this.openExpression();
                    } else {
                        return false;
                    }
                });
        }
    }

    async printItem(): Promise<void> {
        this.isButtonDisabled = true;
        this.fuseProgressBarModule.show();

        try {
            if (
                this.document.format === "docx" ||
                this.document.format === "rtf"
            ) {
                await this.medicalProvider.onRequestSaveAs(this.configonly.key);

                await new Promise((resolve) => setTimeout(resolve, 2000));

                const x = await this.medicalProvider.generateRequestPdfByGcp(
                    this.document.id,
                    this.data.performer.id,
                    this.data.patient.id,
                );

                const pdf = x.pdf as string;

                if (!pdf) {
                    throw new Error("PDF não foi retornado pela API.");
                }

                this.fuseProgressBarModule.hide();

                const dialogRef = this.dialog.open(PrintGcpComponent, {
                    height: "80%",
                    width: "80%",
                    data: { pdf },
                    restoreFocus: false,
                });

                dialogRef.afterClosed().subscribe(() => {
                    this.pdfSrc = null;
                });
            } else {
                this.medicalProvider
                    .generateRequestPdfByGcp(
                        this.document.id,
                        this.data.performer.id,
                        this.data.patient.id,
                    )
                    .then((x) => {
                        let pdf = x.pdf as string;
                        var newBlob = new Blob([x], {
                            type: "application/pdf",
                        });
                        const nav = window.navigator as any;

                        if (nav && nav.msSaveOrOpenBlob) {
                            nav.msSaveOrOpenBlob(newBlob);
                            this.isButtonDisabled = false;
                            return;
                        }

                        const data = window.URL.createObjectURL(newBlob);

                        this.fuseProgressBarModule.hide();
                        const dialogRef = this.dialog.open(PrintGcpComponent, {
                            height: "80%",
                            width: "80%",
                            data: { pdf },
                            restoreFocus: false,
                        });

                        dialogRef.afterClosed().subscribe(() => {
                            this.pdfSrc = null;
                        });

                        this.isButtonDisabled = false;
                    })
                    .catch((err) => {
                        console.error("Erro ao gerar PDF", err);
                        this.isButtonDisabled = false;
                        this.fuseProgressBarModule.hide();
                    });
                this.fuseProgressBarModule.hide();
            }
        } catch (err) {
            console.error("Erro ao imprimir documento", err);
            this.fuseProgressBarModule.hide();
        } finally {
            this.isButtonDisabled = false;
        }
    }

    deleteDocument(id: number, event?: Event) {
        if (event) {
            this.stopPropagation(event);
        }
        this.fuseProgressBarModule.show();
        const confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.componentInstance.deleteMessage =
            "Deseja excluir este documento?";

        confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.medicalProvider.delete(id).then((res) => {
                    this.snackBar.successMessage("Documento deletado!");
                    this.fuseProgressBarModule.hide();
                });
            }
        });
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    viewDocument(event: Event, document: any) {
        this.stopPropagation(event);
        console.log(document);

        if (this.document.format == "docx" || this.document.format == "rtf") {
            this.destroy();
        }
        this.getDocumentById(document.id);
    }

    destroy() {
        this.only.onDestroyEditor();
    }

    newDocument() {
        this.document = new Document();
        this.documentForm.setValue(null);
        this.modelsControl.setValue(null);
        this.modelsControl.enable();
    }
}
